<div class="card m-1">
  <p-breadcrumb [model]="breadItems"></p-breadcrumb>
</div>
<div class="card m-1">

  <div class="card-header bg-gradient-gray-dark text-orange">
    <i class="nav-icon fas fa-chart-line"></i>&nbsp;
    <strong>Total Graphs</strong>
  </div>
  <div class="card-body">
    <p-dropdown [options]="graphs" [(ngModel)]="selectedGraph" (onChange)="onSelectGraph()" optionLabel="totalGraphName" [filter]="true" filterBy="totalGraphName"
                [showClear]="true" (onClear)="onUnselectGraph()" placeholder="Select a Graph" [style]="{'width':'100%'}">
      <ng-template pTemplate="selectedItem">
        <div class="flex align-items-center gap-2" *ngIf="selectedGraph">
          <div>{{ selectedGraph.totalGraphName }}</div>
        </div>
      </ng-template>
      <ng-template let-graph pTemplate="item">
        <div class="flex align-items-center gap-2">
          <div>{{ graph.totalGraphName }}</div>
        </div>
      </ng-template>
    </p-dropdown>

    <div *ngIf="showGraph">
      <app-single-graph [readingList]="totalReadings" [graphName]="selectedGraph.totalGraphName" [interfacesIds]="interfacesIds"></app-single-graph>
    </div>

  </div>
</div>


    <!--<div class="row" style="zoom:100%;">
      <div class="col-12 ">
        <label class="block">Total Graph</label>


      </div>


    </div>-->


